import axiosInstanceClient from "../Common/Axios/axiosInstanceClient";
import API from "../Common/Endpoint/serviceConstrants";

export const callVendorOrderPostApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.post(API.vendororder, payload);
  return data;
};
